/**
 * Lookbook Hotspot Tooltip Positioning
 * Prefers showing tooltip to the left when hotspot is past the midpoint,
 * but falls back to the right if the tooltip would be clipped by the wrapper.
 */
(function () {
  function positionTooltips() {
    var wrapper = document.querySelector('.lalebu-lookbook__slider-wrap');
    if (!wrapper) return;

    var wrapperRect = wrapper.getBoundingClientRect();
    var hotspots = wrapper.querySelectorAll('.lalebu-lookbook__hotspot');

    hotspots.forEach(function (hotspot) {
      var tooltip = hotspot.querySelector('.lalebu-lookbook__hotspot-tooltip');
      if (!tooltip) return;

      var item = hotspot.closest('.lalebu-lookbook__item');
      if (!item) return;

      var itemRect = item.getBoundingClientRect();
      var hotspotRect = hotspot.getBoundingClientRect();
      var hotspotCenter = hotspotRect.left + hotspotRect.width / 2;
      var itemMidpoint = itemRect.left + itemRect.width * 0.55;
      var gap = 12; // 0.75rem

      // Default: show to the right
      tooltip.style.left = 'calc(100% + 0.75rem)';
      tooltip.style.right = 'auto';

      // Only try left side if hotspot is past the midpoint of its image
      if (hotspotCenter > itemMidpoint) {
        // Measure tooltip width while hidden
        var prevVis = tooltip.style.visibility;
        var prevOp = tooltip.style.opacity;
        var prevPtr = tooltip.style.pointerEvents;
        tooltip.style.visibility = 'hidden';
        tooltip.style.opacity = '1';
        tooltip.style.pointerEvents = 'none';
        var tooltipWidth = tooltip.offsetWidth;
        tooltip.style.visibility = prevVis;
        tooltip.style.opacity = prevOp;
        tooltip.style.pointerEvents = prevPtr;

        // Check if tooltip fits on the left without being clipped by the wrapper
        var leftEdge = hotspotRect.left - gap - tooltipWidth;
        if (leftEdge >= wrapperRect.left) {
          tooltip.style.left = 'auto';
          tooltip.style.right = 'calc(100% + 0.75rem)';
        }
        // Otherwise keep it on the right (already set above)
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', positionTooltips);
  } else {
    positionTooltips();
  }

  window.addEventListener('resize', positionTooltips);
})();
